import { css } from '@emotion/core'

export const tileSizeToStyles = {
  s: css`
    width: 159px;
    height: 76px;
  `,
  flex: css`
    width: 100%;
    aspect-ratio: 2.09 / 1;
  `,
}
